/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'keyboard-tab': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 18h2V6h-2m-8.41 1.41L15.17 11H1v2h14.17l-3.58 3.58L13 18l6-6-6-6-1.41 1.41z"/>'
  }
})
